import { useState } from "react";
import { Link } from "react-router-dom";
import LegalModal from "@/components/LegalModal";
import { STORE, LEGAL_SHIPPING } from "@/config/store";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "@/config/pogoConfig";

export default function Footer() {
  const [shippingOpen, setShippingOpen] = useState(false);

  return (
    <footer data-testid="site-footer" className="px-5 pt-10 pb-8 border-t border-ink/10">
      <div className="max-w-2xl mx-auto flex flex-col gap-4">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-ink/50">
          <Link
            data-testid="footer-privacy-link"
            to="/privacy"
            className="underline underline-offset-4 font-medium"
          >
            Privacy
          </Link>
          <Link
            data-testid="footer-terms-link"
            to="/terms"
            className="underline underline-offset-4 font-medium"
          >
            Terms
          </Link>
          <button
            data-testid="footer-shipping-link"
            type="button"
            onClick={() => setShippingOpen(true)}
            className="underline underline-offset-4 font-medium"
          >
            Shipping
          </button>
          <Link
            data-testid="footer-returns-link"
            to="/returns-exchanges"
            className="underline underline-offset-4 font-medium"
          >
            Returns &amp; Exchanges
          </Link>
          <a
            data-testid="footer-instagram-link"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="underline underline-offset-4 font-medium"
          >
            Instagram {INSTAGRAM_HANDLE}
          </a>
          <span data-testid="footer-contact">
            Contact: {STORE.contactEmail}
          </span>
        </div>
        <p className="text-xs text-ink/50">© 2026 POSSO. All rights reserved.</p>
      </div>
      <LegalModal
        open={shippingOpen}
        onClose={() => setShippingOpen(false)}
        title="Shipping."
        body={LEGAL_SHIPPING}
        testId="shipping-modal"
      />
    </footer>
  );
}
